import BaseModel from "./BaseModel";

/**
 * CourseModuleVideoResourse 
 */
export default class CourseModuleVideoResourse extends BaseModel{

  constructor({
    id,
    course_module_video,
    title,
    file_path,
    created_at,
    updated_at,
    deleted_at,
  }) {
    super();
    
    this.id = id || null;
    this.course_module_video = course_module_video || null;
    this.title = title || null;
    this.file_path = file_path || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
    this.deleted_at = deleted_at || null;
  }

  /**
   * Gets file extension
   * @returns {string}
   */
  getExtension() {
    const list = this.file_path ? this.file_path.split('.') : [];
    return list.length > 1 ? list[1] : '';
  }
}